import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {NotificationRouteENUM} from '../../user/enums/notification-route.enum';

@Injectable()
export class NotificationService {


  constructor(private _http: HttpClient) {
  }

  getListByUser(params) {
    return this._http.post<any>('api/a/notification/list/by/user', params);
  }

  updateUserStatus(notificationId: string, userId: number) {
    return this._http.put<any>(`api/a/notification/update/status/${notificationId}/${userId}`, null);
  }
  deleteByUser(userNotificationDto) {
    return this._http.put<any>(`api/a/notification/delete/`, userNotificationDto);
  }

  goToPage(item: any, router: Router) {
    const type = NotificationRouteENUM[item.routeType];
    if (type) {
      if (item.linkParams) {
        const path = item.linkParams['path'];
        const query = item.linkParams['query'];
        console.log(path)
        if (path && query) {
          router.navigate([type.route + '/' +  path], {queryParams: NotificationRouteENUM.convertQueryParams(query)});
        } else if (path) {
          router.navigate([type.route + '/' + path]);
        } else if (query) {
          router.navigate([type.route], {queryParams: NotificationRouteENUM.convertQueryParams(query)});
        }

      } else {
        router.navigate([type.route]);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/services/notification.service.ts